import { OS_TYPES } from 'constants/platformTech'

const overwriteOs = (platformTech) => {
  const modifiedPlatformTech = { ...platformTech }
  if (modifiedPlatformTech.isWebApp) modifiedPlatformTech.os = 3 // Web;
  return modifiedPlatformTech
}

export const mapAppVersionDetail = (appVersion) => {
  const { platformTech } = appVersion
  overwriteOs(platformTech)

  const platformOS = OS_TYPES[platformTech.os] || ''

  const title = `${platformOS} - ${appVersion.version}`

  return { ...appVersion, title, platformOS }
}

export const mapAppVersions = (appVersions) => {
  appVersions.items.map((version) => {
    return overwriteOs(version.platformTech)
  })
  return { ...appVersions }
}
